import React from "react";
import { Icon } from "@iconify/react";

const Hero = () => {
  return (
    <>
      {/* ==================== DESKTOP HERO (Unchanged) ==================== */}
      <section className="home-section-2 home-section-bg pt-0 overflow-hidden d-none d-lg-block">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-12">
              <div className="slider-animate">
                <div>
                  <div className="home-contain rounded-0 p-0 position-relative">
                    {/* <div
                      className="hero-banner"
                      style={{
                        backgroundImage: `url('/assets/images/Evercore_Banner.webp')`,
                      }}
                    /> */}
                    <div
                      className="hero-banner"
                      style={{
                        backgroundImage: `url('/assets/images/EV_New_Banner.jpeg')`,
                      }}
                    />

                    {/* OLD HERO CODE */}
                    {/* <div className="home-detail home-big-space p-center-left home-overlay">
                      <div className="container-fluid-lg">
                        <div>
                          <h6 className="ls-expanded theme-color text-uppercase">
                            New Generation Protein
                          </h6>
                          <h1 className="heding-2">
                            Unlock Your Full Potential With Yeast And Collagen.
                          </h1>
                          <h5 className="text-content text-width-p">
                            Experience the sustainable, gut-friendly power of
                            Evercore yeast Protein. Complete amino acid profile,
                            zero bloating, and incredible taste in every scoop.
                          </h5>

                          <a href="/Shop">
                            <button className="pro-acc-logout-btn btn-md text-white fw-bold mt-md-5 mend-auto">
                              Shop Now{" "}
                              <i className="fa-solid fa-arrow-right icon"></i>
                            </button>
                          </a>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ==================== MOBILE HERO - Text First + Image Below (Like Old Height) ==================== */}
      {/* ==================== MOBILE HERO ==================== */}
      <section
        className="d-lg-none"
        style={{
          position: "relative",
          width: "100%",
          margin: 0,
          padding: 0,
          backgroundColor: "#d6e4f0",
          zIndex: 0 /* ✅ hero sits at z=0, below sidebar */,
        }}
      >
        {/* <img
          src="/assets/images/Evercore_Banner.webp"
          alt=""
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            margin: 0,
            padding: 0,
          }}
        /> */}
        <img
          src="/assets/images/EV_New_Banner.jpeg"
          alt=""
          style={{
            width: "100%",
            height: "auto",
            display: "block",
            margin: 0,
            padding: 0,
          }}
        />

        {/* Text overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "50%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            padding: "12px 16px",
            zIndex: 1 /* ✅ above image but still below sidebar */,
            pointerEvents:
              "none" /* ✅ sidebar clicks pass through hero layer */,
          }}
        >
          {/* keep your existing text content unchanged */}
          {/* <h6
            style={{
              fontSize: "0.6rem",
              letterSpacing: "1px",
              color: "#000",
              textTransform: "uppercase",
              marginBottom: "6px",
              lineHeight: "1.2",
            }}
          >
            New Generation Protein
          </h6> */}
{/* 
          <h2
            style={{
              fontSize: "0.85rem",
              lineHeight: "1.3",
              color: "#000",
              fontWeight: "700",
              marginBottom: "6px",
            }}
          >
            Unlock Your Full Potential With Yeast And Collagen.
          </h2> */}
{/* 
          <p
            style={{
              fontSize: "0.6rem",
              color: "rgba(0,0,0,0.75)",
              lineHeight: "1.4",
              marginBottom: "10px",
            }}
          >
            Sustainable, gut-friendly yeast protein. Complete amino acid
            profile, zero bloating.
          </p> */}

          {/* ✅ button needs pointerEvents back so it stays clickable */}
          {/* <a
            href="/Shop"
            style={{ textDecoration: "none", pointerEvents: "auto" }}
          >
            <button
              style={{
                backgroundColor: "#000",
                color: "#fff",
                border: "none",
                borderRadius: "50px",
                padding: "5px 14px",
                fontSize: "0.6rem",
                fontWeight: "700",
                cursor: "pointer",
                lineHeight: "1.4",
              }}
            >
              Shop Now →
            </button>
          </a> */}
        </div>
      </section>

      {/* ==================== TRUST STRIP (Common) ==================== */}
      <section className="micro-trust-strip">
        <div className="trust-container">
          <div className="trust-item">
            <Icon icon="mdi:flask-outline" />
            <span>Lab Tested</span>
          </div>
          <div className="trust-item">
            <Icon icon="mdi:factory" />
            <span>GMP Certified</span>
          </div>
          <div className="trust-item">
            <Icon icon="mdi:clipboard-check-outline" />
            <span>FSSAI Approved</span>
          </div>
          <div className="trust-item">
            <Icon icon="mdi:leaf" />
            <span>No Added Sugar</span>
          </div>
          <div className="trust-item">
            <Icon icon="mdi:shield-check-outline" />
            <span>Clean Nutrition</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
